import { ref } from '@vue/composition-api'
import store from '@/store'
import { errorNotification, successNotification } from '@/utils/toast-notifications'

export default function useDocumentsList(props, ctx) {
  const documentToChange = ref(null)
  const loadingDocStatus = ref(false)
  const documentId = props?.document?.documentId
  const driverId = props?.resourceId
  const docStatus = ref('')
  const resolveDocumentStatus = doc => {
    const uploaded = doc?.documentUrl
    if (uploaded) return { variant: 'success', text: 'Uploaded' }
    return { variant: 'danger', text: 'Not Uploaded' }
  }

  const resolveDocStatus = status => {
    if (status === 'VALID') return { variant: 'success' }
    return { variant: 'danger' }
  }

  const fetchDocuments = (type, typeId) => new Promise(resolve => {
    store.dispatch(
      'documents/fetchDocuments',
      {
        type: `${type}s`,
        typeId,
      },
    ).then(fetchedDocuments => {
      documentToChange.value = null
      resolve(fetchedDocuments)
    })
  })
  const handleDocStatus = async status => {
    try {
      loadingDocStatus.value = true
      const result = await store.dispatch('documents/handleDocumentStatus', {
        documentId,
        driverId,
        status,
      })
      successNotification('Updated Successfully')
      docStatus.value = result?.data?.data?.status
      ctx.emit('updated-document-status')
    } catch (error) {
      console.log(error)
      errorNotification('Try again')
    } finally {
      loadingDocStatus.value = false
    }
  }
  return {
    documentToChange,
    resolveDocumentStatus,
    fetchDocuments,
    handleDocStatus,
    loadingDocStatus,
    docStatus,
    resolveDocStatus,
  }
}
